export default __webpack_public_path__ + "static/media/logo.da8639a3.png";